(function($, Drupal) {
  // Sidenav navigation JS
  Drupal.behaviors.initLanguageSwitcher = {
    attach: function(context, settings) {
      $(".js_langSwitch", context)
        .once("initLanguageSwitcher")
        .each(function() {
          let $el = $(this),
            $menu = $el.find(".langswitch__trigger"),
            $langList = $el.find(".langswitch__list"),
            $langListClose = $el.find(".langswitch__close"),
            $mobileTrigger = $(".js_langSwitchMobile"),
            $resPixel = $(".js_resolution"),
            $flag = false;

          function clearActive() {
            $langListClose.removeClass("is_active");
            $langList.removeClass("is_open");
            $menu.removeClass("is_active");
          }

          function callList() {
            if (!$flag) {
              $flag = true;
              setTimeout(function() {
                $flag = false;
              }, 100);

              $langListClose.toggleClass("is_active");
              $langList.toggleClass("is_open");
              $menu.toggleClass("is_active");
            }
            return false;
          }

          $menu
            .add($mobileTrigger)
            .add($langListClose)
            .on("click", function(evt) {
              evt.preventDefault();
              evt.stopPropagation();
              let $body = $("body");

              if (
                $body.hasClass("is_sticky") &&
                $resPixel.css("opacity") < "1"
              ) {
                setTimeout(function() {
                  callList();
                }, 300);
              } else {
                callList();
              }
            });

          function copyUserUrl() {
            // Setup mobile User Profile link (copy it from real usernav to mobile nav)
            let $url = $(".usernav__list")
                .find('a[class$="userlogin"]')
                .attr("href"),
              $link = $(".js_mainNavigation").find(".nav__link--account");

            $link.attr("href", $url);
          }

          $mobileTrigger.html($menu.html());
          copyUserUrl();

          $langList.on("click", function() {
            clearActive();
          });

          const trigger = throttle(e => {
            clearActive();
          }, 500);

          $(window).resize(trigger);
        });
    }
  };
})(jQuery, Drupal);
